var React = require('react');

const Legend = (props) => {
    return (
        <div id="calendar-legend" className="legend" key="calendarLegendContainer">
            <div className="legend-item" key="calendarLegendItem1">
                <div className="available color-block" key="calendarLegendItem1block"></div> <label key="calendarLegendItem1label">{ props.t.trans('calendar.available_arrival', {}, 'messages') }</label>
            </div>
            {!props.static || (props.static && props.interactive) ?
            <div className="legend-item" key="calendarLegendItem2">
                <div className="selected color-block" key="calendarLegendItem2block"></div> <label key="calendarLegendItem2label">{ props.t.trans('calendar.selected_dates', {}, 'messages') }</label>
            </div>
            :''}
            <div className="legend-item" key="calendarLegendItem3">
                <div className="arrival-forbidden color-block" key="calendarLegendItem3block"></div> <label key="calendarLegendItem3label">{ props.t.trans('calendar.not_allowed', {}, 'messages') }</label>
            </div>
        </div>
    );
}

export default Legend;
